type GetOtpCodeLengthErrorArgs = {
  code?: string | null;
};

export const validateOtpCode = ({
  code,
}: GetOtpCodeLengthErrorArgs): boolean => {
  const normalizedCode = (code ?? '').trim();

  if (normalizedCode.length !== 6) {
    return false;
  }

  return true;
};

export default {
  validateOtpCode,
};
